{
  "list": {
    "heading": "Unidad",
    "loading": "Cargando la lista de la unidad …",
    "failed": "No se pudo cargar la lista de la unidad.",
    "retry": "Intentar de nuevo",
    "notFound": "La unidad no existe en la historia clínica.",
    "empty": "No hay pacientes ingresados en la unidad.",
    "caption": "Pacientes de la unidad, una fila por cama.",
    "occupancy": "{occupied} de {total} camas ocupadas{withoutBed, plural, =0 {} other { · # sin cama}}",
    "occupancyWithoutTotal": "{occupied, plural, =0 {Ningún paciente ingresado} one {# paciente ingresado} other {# pacientes ingresados}}"
  },
  "column": {
    "bed": "Cama",
    "name": "Nombre",
    "identifier": "Personnummer / reservnummer",
    "age": "Edad",
    "admitted": "Ingreso",
    "responsible": "Médico responsable",
    "safety": "Alertas"
  },
  "picker": {
    "label": "Mostrar unidad"
  },
  "patient": {
    "responsibleNotDocumented": "No documentado"
  }
}
